import React from "react";
import styles from "./AppSidebar.module.css";
import {
  FaBars,
  FaTimes,
  FaLinkedinIn,
  FaInstagram,
  FaGithub,
  FaRegEnvelope  
} from "react-icons/fa";

import { SiGmail } from "react-icons/si";

import logo from "../../images/logo-rg-2.png";
import profile from "../../images/rics-white-bg.png";
import profileShy from "../../images/rics-shy.png";

import { Link } from 'react-scroll';

import { useState, useEffect } from "react";

import AOS from 'aos';
import 'aos/dist/aos.css';

const AppSidebar = () => {
  const [isProfileHover, setIsProfileHover] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [scroll, setScroll] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScroll(!scroll);
    } else {
      setScroll(scroll);
    }
  };
  
  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({
      once: true
    });
  }, []);


  return(
    <div className={styles.AppSidebar} data-testid="AppSidebar">
      <div className={styles.Logo}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="logo-wrapper">
            <a href="/">
              <img src={logo} className={styles.LogoImg} alt="rico-guinanao-logo" width="30px" />
            </a>
          </div>
          <button onClick={handleToggleSidebar} className={styles.BarsButton + " btn h-100 outline-none"}>
            {
              isSidebarOpen ? <FaTimes className={styles.CloseNav + " text-white"} size={30} /> : <FaBars className={styles.OpenNav + " text-white"} size={30} />
            }
          </button>
        </div>
      </div>
      {
        isSidebarOpen ? (
          <div onClick={handleToggleSidebar} className={styles.AppNavBackdrop+` ${scroll > 0 ? styles.AppNavHide : styles.AppNavShow} ${ isSidebarOpen ? styles.AppNavShow : styles.AppNavHide }`}>
            <Link className={styles.AppLink+' text-decoration-none fw-bold p-2 fs-5'} to="about">
              [ <span>About</span> ]
            </Link>
            <Link className={styles.AppLink+' text-decoration-none fw-bold p-2 fs-5'} to="experience">
              [ <span>Experience</span> ]
            </Link>
            <Link className={styles.AppLink+' text-decoration-none fw-bold p-2 fs-5'} to="projects">
              [ <span>Projects</span> ]
            </Link>
            <Link className={styles.AppLink+' text-decoration-none fw-bold p-2 fs-5'} to="contact">
              [ <span>Contact</span> ]
            </Link>
          </div>
        ) : null  

      }
     
      <div className={styles.SidebarContent}>
        <div className={styles.PersonalInfo}>
          <div className={styles.SidebarContentHeader}>
            <div className={styles.SidebarContentHeaderProfileImage} data-aos="zoom-in" data-aos-duration="500" data-aos-delay="100">
              <img
                src={isProfileHover ? profileShy : profile}
                alt="rico-guinanao-logo"
                style={{cursor: "pointer"}}
                onMouseEnter={() => setIsProfileHover(true)}
                onMouseLeave={() => setIsProfileHover(false)}
              />
            </div>
            <div className={styles.SidebarContentHeaderTitle} data-aos="zoom-in" data-aos-duration="500" data-aos-delay="200">
              <h1>RICO GUINANAO</h1>
            </div>
            <div className={styles.SidebarContentHeaderSubtitle} data-aos="zoom-in" data-aos-duration="500" data-aos-delay="300">
              <h4>FULL STACK WEB DEVELOPER</h4>
            </div>
          </div>
        </div>
        {/* <div className={styles.ShortIntro} data-aos="fade-down" data-aos-duration="500" data-aos-delay="400">
          <div className={styles.IntroWrapper}>
            <p className="text-center" style={{ fontSize: "18px" }}>
              A hard-working Web Developer that can create intuitive user interfaces and effective solutions.
            </p>
            <hr className="m-0"></hr>
            <div className={styles.ButtonWrapper}>
              <a
                href="mailto:guinanaorico@gmail.com"
                className={
                  styles.ButtonContactText +
                  " btn btn-primary rounded-5 btn-lg mt-3 py-3 fw-bold"
                }
              >
                Send an email
              </a>
            </div>
          </div>
        </div> */}
        <div className={styles.SocMed + " mt-4 mx-5"}>
          <div className={styles.SocMedItems} data-aos="fade-right" data-aos-duration="500" data-aos-delay="650">
            <a
              class="text-decoration-none"
              href="https://github.com/coricss"
              target="_blank"
            >
              <button
                class={
                  styles.BtnSocmed +
                  " btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                }
              >
                <FaGithub className={styles.SocMedIcon} size={25} />
              </button>
            </a>
            
          </div>
          <div className={styles.SocMedItems} data-aos="fade-right" data-aos-duration="500" data-aos-delay="450">
            <a
              class="text-decoration-none"
              href="https://www.linkedin.com/in/guinanaorico"
              target="_blank"
            >
              <button
                class={
                  styles.BtnSocmed +
                  " btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                }
              >
                <FaLinkedinIn className={styles.SocMedIcon} size={25} />
              </button>
            </a>
          </div>
          <div className={styles.SocMedItems} data-aos="fade-left" data-aos-duration="500" data-aos-delay="450">
            <a
              class="text-decoration-none"
              href="mailto:ricoguinanao.career@gmail.com"
              target="_blank"
            >
              <button
                class={
                  styles.BtnSocmed +
                  " btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                }
              >
                <SiGmail className={styles.SocMedIcon} size={25} />
              </button>
            </a>
          </div>
         {/*  <div className={styles.SocMedItems} data-aos="fade-left" data-aos-duration="500" data-aos-delay="450">
            <a
              class="text-decoration-none"
              href="https://x.com/corix__"
              target="_blank"
            >
              <button
                class={
                  styles.BtnSocmed +
                  " btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                }
              >
                <FaXTwitter className={styles.SocMedIcon} size={25} />
              </button>
            </a>
          </div> */}
          <div className={styles.SocMedItems} data-aos="fade-left" data-aos-duration="500" data-aos-delay="650">
            <a
              class="text-decoration-none"
              href="https://www.instagram.com/_corixx"
              target="_blank"
            >
              <button
                class={
                  styles.BtnSocmed +
                  " btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                }
              >
                <FaInstagram className={styles.SocMedIcon} size={25} />
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

AppSidebar.propTypes = {};

AppSidebar.defaultProps = {};

export default AppSidebar;
